import styled from "styled-components";
import { devices } from '../../../../src/globalStyle'

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  font-family: 'Inter', sans-serif;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  padding-bottom: 3rem;
`

export const ListContent = styled(Content)`
  overflow: hidden;

  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
  padding-bottom: 0;
`

export const FilterDiv = styled.div`
  display: flex;
  width: 7vw;
  border: 1.6px solid #0090d3;
  background-color: #fff;
  border-radius: 1.5vw;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 5vw;
    height: 4vh;
  }
`

export const FilterImg = styled.img`
  margin-left: 0.7vw;
  height: 4vh;
  @media ${devices.largeDesktop} {
    margin-left: 0.4vw;
    height: 3vh;
  }
`

export const FilterText = styled.h2`
  margin-left: 0.3vw;
  font-size: 0.95vw;
  color: #0090d3;

  @media ${devices.largeDesktop} {
    margin-left: 0.2vw;
    font-size: 0.75vw;
  }
`

export const ButtonCreate = styled.button`
  font-weight: bold;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding: 12px 24px;
  width: 170px;
  color: #fff;
  cursor: pointer;
  background-color: #0090D3;
  border: none;
  border-radius: 100px;
  img{
    height: 0.9rem;
    margin-right: 0.4rem;
  }
`

export const ButtonCancel = styled(ButtonCreate)`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  width: auto;
  padding: 12px 18px;
  min-width: 130px;
  &:hover {
    background-color: #f0f8ff;
  }
`

export const BlurBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0.4); 
    z-index: 1000;
    display: flex; 
    justify-content: center; 
    align-items: center;
`;

export const PageBreadcrumb = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;
`;

export const PageBreadcrumbPrimary = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #0090D3;
`;

export const PageBreadcrumbSecondary = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #696969;
`;
